import React from 'react';

import CN from './SectionLabel.module.scss';

const SectionLabel = ({ children }) => (
  <div data-bem="SectionLabel" className={CN.component}>
    {children}
  </div>
);

export default SectionLabel;
